import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

const STORAGE_KEY = 'tamilFont';
const VALID = ['noto', 'kavivanar'];

const TamilFontContext = createContext(null);

export const useTamilFont = () => {
  const ctx = useContext(TamilFontContext);
  if (!ctx) throw new Error('useTamilFont must be used within a TamilFontProvider');
  return ctx;
};

export function TamilFontProvider({ children }) {
  const [tamilFont, setTamilFont] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return VALID.includes(saved) ? saved : 'noto';
  });

  useEffect(() => {
    document.documentElement.dataset.tamilFont = tamilFont;
    localStorage.setItem(STORAGE_KEY, tamilFont);
  }, [tamilFont]);

  const toggleTamilFont = useCallback(() => {
    setTamilFont(prev => (prev === 'noto' ? 'kavivanar' : 'noto'));
  }, []);

  const value = useMemo(
    () => ({ tamilFont, toggleTamilFont, setTamilFont }),
    [tamilFont, toggleTamilFont]
  );

  return <TamilFontContext.Provider value={value}>{children}</TamilFontContext.Provider>;
}
